const collectionFactories = {
    actuators: () => new WiseMetering.Collection.Actuators(),
    actuatorKinds: () => new WiseMetering.Collection.ActuatorKinds(),
    alarms: () => new WiseMetering.Collection.Alarms(),
    allocations: () => new WiseMetering.Collection.Allocations(),
    analyzeViews: () => new WiseMetering.Collection.AnalyzeViews(),
    apiRequests: () => new WiseMetering.Collection.ApiRequests(),
    siteTags: () => new WiseMetering.Collection.SiteTags(),
    sitePackages: () => new WiseMetering.Collection.SitePackages(),
    circuitTags: () => new WiseMetering.Collection.CircuitTags(),
    circuits: () => new WiseMetering.Collection.Circuits(),
    companies: () => new WiseMetering.Collection.Companies(),
    contracts: () => new WiseMetering.Collection.Contracts(),
    countries: () => new WiseMetering.Collection(),
    currencies: () => [],
    dashboardEvents: () => new WiseMetering.Collection.Events(),
    devices: () => new WiseMetering.Collection.Devices(),
    utilities: () => new WiseMetering.Collection.Utilities(),
    etlDrivers: () => [],
    etlRates: () => [],
    etls: () => new WiseMetering.Collection.Etls(),
    externalAssets: () => new WiseMetering.Collection.ExternalAssets(),
    folders: () => new WiseMetering.Collection.Folders(),
    globalReportTypes: () => new WiseMetering.Collection.GlobalReportTypes(),
    groups: () => new WiseMetering.Collection.Groups(),
    holidays: () => new WiseMetering.Collection.Holidays(),
    indicators: () => new WiseMetering.Collection.Indicators(),
    indicatorKinds: () => new WiseMetering.Collection(),
    integrationConfigurations: () => new WiseMetering.Collection.IntegrationConfigurations(),
    integrationLicenses: () => new WiseMetering.Collection.IntegrationLicenses(),
    integrationLicenseLogs: () => new WiseMetering.Collection.IntegrationLicenseLogs(),
    integrations: () => new WiseMetering.Collection.Integrations(),
    integrationPartners: () => new WiseMetering.Collection.IntegrationPartners(),
    invoices: () => new WiseMetering.Collection.Invoices(),
    leads: () => new WiseMetering.Collection.Leads(),
    markers: () => new WiseMetering.Collection.Markers(),
    markerTypes: () => new WiseMetering.Collection(),
    metadataTypes: () => new WiseMetering.Collection(),
    notifications: () => new WiseMetering.Collection.Notifications(),
    objectives: () => new WiseMetering.Collection.Objectives(),
    opportunities: () => new WiseMetering.Collection.Opportunities(),
    organizationLogs: () => new WiseMetering.Collection.OrganizationLogs(),
    reports: () => new WiseMetering.Collection.Reports(),
    rootObjects: () => new WiseMetering.Collection.RootObjects(),
    siteDocuments: () => new WiseMetering.Collection.SiteDocuments(),
    seus: () => new WiseMetering.Collection.Seus(),
    scheduledReports: () => new WiseMetering.Collection.ScheduledReports(),
    systemCategories: () => new WiseMetering.Collection(),
    tariffs: () => new WiseMetering.Collection.Tariffs(),
    tariffTypes: () => new WiseMetering.Collection.TariffTypes(),
    tars: () => new WiseMetering.Collection.Tars(),
    temperatureColors: () => [],
    tenants: () => new WiseMetering.Collection.Tenants(),
    tenantInvoices: () => new WiseMetering.Collection.TenantInvoices(),
    plans: () => new WiseMetering.Collection.Plans(),
    timezones: () => ({}),
    units: () => new WiseMetering.Collection(),
    users: () => new WiseMetering.Collection.Users(),
    utilityKinds: () => new WiseMetering.Collection.UtilityKinds(),
    zone_attribute_values: () => new WiseMetering.Collection.ZoneAttributeValues(),
    zone_attributes: () => new WiseMetering.Collection.ZoneAttributes(),
    zoneCategories: () => new WiseMetering.Collection(),
    zoneReportTypes: () => new WiseMetering.Collection.ZoneReportTypes(),
    zones: () => new WiseMetering.Collection.Zones()
};

const collectionEventConfigs = [
    {
        collectionName: 'actuators',
        parentAccessor: 'circuit',
        addEvent: 'change:addActuator',
        removeEvent: 'change:removeActuator',
        bindChange: true
    },
    {
        collectionName: 'allocations',
        parentAccessor: 'parent',
        addEvent: 'change:children:addAllocation',
        removeEvent: 'change:children:removeAllocation'
    },
    {
        collectionName: 'zones',
        parentAccessor: 'parent',
        addEvent: 'change:children:addZone',
        removeEvent: 'change:children:removeZone'
    },
    {
        collectionName: 'zone_attribute_values',
        parentAccessor: 'zone',
        addEvent: 'change:addAttributeValue',
        removeEvent: 'change:removeAttributeValue',
        bindChange: true,
        includeModel: false
    },
    {
        collectionName: 'folders',
        parentAccessor: 'parent',
        addEvent: 'change:children:addFolder',
        removeEvent: 'change:children:removeFolder'
    },
    {
        collectionName: 'circuits',
        parentAccessor: 'parent',
        addEvent: 'change:children:addCircuit',
        removeEvent: 'change:children:removeCircuit'
    },
    {
        collectionName: 'contracts',
        parentAccessor: 'parent',
        addEvent: 'change:children:addContract',
        removeEvent: 'change:children:removeContract'
    },
    {
        collectionName: 'utilities',
        parentAccessor: 'parent',
        addEvent: 'change:children:addUtility',
        removeEvent: 'change:children:removeUtility'
    },
    {
        collectionName: 'indicators',
        parentAccessor: 'parent',
        addEvent: 'change:children:addIndicator',
        removeEvent: 'change:children:removeIndicator',
        bindChange: true
    },
    {
        collectionName: 'seus',
        parentAccessor: 'parent',
        addEvent: 'change:children:addSeu',
        removeEvent: 'change:children:removeSeu'
    },
    {
        collectionName: 'tenants',
        parentAccessor: 'parent',
        addEvent: 'change:children:addTenant',
        removeEvent: 'change:children:removeTenant'
    }
];

const getParentModel = (model, parentAccessor) => {
    if (typeof model?.[parentAccessor] !== 'function') {
        return null;
    }

    return model[parentAccessor]();
};

const triggerParentChange = ({ parent, eventName, includeModel, model }) => {
    if (!parent) {
        return;
    }

    if (includeModel === false) {
        parent.trigger(eventName);
        return;
    }

    parent.trigger(eventName, model);
};

const bindCollectionEventsFor = ({ collectionName, parentAccessor, addEvent, removeEvent, bindChange = false, includeModel = true }) => {
    const collection = WiseMetering[collectionName];

    collection.on('add', model => {
        if (bindChange && typeof model.bindChange === 'function') {
            model.bindChange();
        }

        const parent = getParentModel(model, parentAccessor);
        triggerParentChange({ eventName: addEvent, includeModel, model, parent });
    });

    collection.on('remove', model => {
        const parent = getParentModel(model, parentAccessor);
        triggerParentChange({ eventName: removeEvent, includeModel, model, parent });
    });
};

export const initializeCollections = () => {
    Object.entries(collectionFactories).forEach(([name, createCollection]) => {
        WiseMetering[name] = createCollection();
    });
};

export const bindCollectionEvents = () => {
    collectionEventConfigs.forEach(bindCollectionEventsFor);
};
